import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { UserStatusEnumType } from '__generated__/graphql';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import FocusLayout from 'layouts/FocusLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

import { logout } from 'utils/auth';

import ReportAccountSuspension from './ReportAccountInactivity';

const INACTIVE_USER_QUERY = gql(`
  query InactiveUser {
    dashboard {
      id
      user {
        id
        status
      }
    }
  }
`);

const InactiveUser: FC = () => {
  const { loading, error, data, refetch } = useQuery(INACTIVE_USER_QUERY);

  if (loading) return <LoadingIndicator />;
  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const user = data.dashboard.user;

  if (
    user.status !== UserStatusEnumType.Inactive &&
    user.status !== UserStatusEnumType.PendingEmailVerification
  ) {
    return <Navigate to="/" />;
  }

  return (
    <FocusLayout>
      <main className="grid min-h-full place-items-center py-32">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">Notice</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Your account is currently inactive or pending email verification
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Complete the necessary steps to regain full access to your AngelList India account.
            Contact our support team for initiating the reactivation process.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <button
              type="button"
              className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={logout}
            >
              Logout
            </button>
            <ReportAccountSuspension />
          </div>
        </div>
      </main>
    </FocusLayout>
  );
};

export default InactiveUser;
